<template>
  <div class="base-gallery">
    <GalleryGrid
      :images="imagesGrid"
      :columns="columns"
    >
      <GallerySlide
        v-for="image in images"
        :key="image.id"
        class="gallery__slide"
        :slide="image"
        @open-image="openImage"
      />
    </GalleryGrid>
    <div
      v-if="isShowCaption"
      class="base-gallery__caption"
    >
      <TheContent
        v-for="content in parsedCaption"
        :key="content.id"
        :elem="content"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { IContentGallery } from '~/types/components/Gallery';
  import TheContent from '~/components/TheContent';
  import FullscreenGallery from '~/components/FullscreenGallery.vue';
  import GallerySlide from '~/components/Gallery/GallerySlide.vue';
  import GalleryGrid from '~/components/Gallery/GalleryGrid.vue';
  import type { TContent, TImageSize } from '~/types/common';
  import type { IContentImage } from '~/types/components/ArticlePicture';
  import { useModal } from '@devhacker/shared/plugins/modal/useModal';

  export default defineNuxtComponent({
    name: 'BaseGallery',
    components: { TheContent, GallerySlide, GalleryGrid },
    props: {
      elem: {
        type: Object as PropType<IContentGallery>,
        required: true,
      },
    },

    computed: {
      images(): IContentImage[] {
        return this.elem.attributes.images;
      },

      imagesGrid(): Array<TImageSize[]> {
        return this.images.map((image: IContentImage) => image.attributes.sizes);
      },

      parsedCaption(): TContent[] | null {
        return this.elem.attributes.parsed_caption;
      },

      slidesUrls(): string[] {
        return this.images.map((item) => item.attributes.url);
      },

      isShowCaption(): boolean {
        return !!(this.parsedCaption && this.parsedCaption.length > 0);
      },

      columns(): number {
        return this.elem.attributes.columns;
      },
    },

    methods: {
      openImage(url: string) {
        useModal().open(
          FullscreenGallery,
          {
            closeClickOutside: true,
            slides: this.slidesUrls,
            activeSlide: url,
          },
          {
            transition: 'modal-fade',
          },
        );
      },
    },
  });
</script>

<style lang="scss" scoped>
  .base-gallery {
    &__caption {
      margin-top: 24px;
    }
  }
</style>
